<template>
  <div class="training-school">
    <div class="search-box">
      <!-- <div class="select-box">
        <span class="select-title">地区：</span>
        <treeSelectt
          :typeOne="typeOne"
          :parentIdOne="parentIdOne"
          style="width: 250px;"
          :key="sid"
          :checkedKeys="defaultCheckedKeys"
          @popoverHide="AddDept"
        ></treeSelectt>
      </div>-->
      <div class="select-box">
        <span class="select-title">标签：</span>
        <el-select v-model="listQuery.label" placeholder="请选择" @change="selectChanged">
          <el-option
            v-for="item in optionsbx"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </div>

      <div class="select-box">
        <span class="select-title">警种：</span>
        <el-select
          @change="selectDatajzDicId"
          v-model="listQuery.JzId"
          clearable
          placeholder="请选择"
          style="width: 140px;"
        >
          <el-option
            v-for="item in optionsDicList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="select-box">
        <span class="select-title">类型：</span>
        <el-select
          @change="selectChanType"
          v-model="listQuery.type"
          clearable
          placeholder="请选择"
          style="width: 140px;"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <el-input
        size="large"
        placeholder="微课搜索"
        v-model="listQuery.title"
        class="input-with-select"
        style="width:300px; color: white;height: 40px;"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="MoocQuestionListssstt"
          class="searchRightBtnCon"
        ></el-button>
      </el-input>
    </div>
    <div class="training-school-inner">
      <div class="training-school-head">
        <img src="@/assets/newIndex/boutique.png" />
        <ul class="training-schoolul">
          <li
            class="training-school-headtext"
            v-for="(item,index) in tablist"
            :key="index"
            :class="{ active: tabActive === index }"
            @click="tabHandleChange(index,item.id)"
          >{{item.title}}</li>
        </ul>

        <div class="gdbox" @click="acadMore()">
          <div class="gdtext"><span>查看更多</span><i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
      <!-- 渐变线条 -->
      <div class="gitern"></div>
      <div class="trainingvideo">
        <div class="trainingvideright">
          <div
            class="trainingimgli"
            v-for="(item,index) in QuestionList"
            :key="index"
            @click="newsVideo(item.id)"
          >
            <img :src="item.imgUrl" />

            <div class="traingimgtext onele">{{item.name}}</div>
            <!-- <div style="padding-left:10px;padding-top:5px">
              <el-rate v-model="item.levels" disabled disabled-void-color="#cccccc"></el-rate>
            </div>-->
            <div class="traingimgtext" style="font-size:12px;color:#666666;line-height:18px;margin: 0px 0px 7px 0px;">{{item.deptName}}</div>
            <div class="traingimgnametxtlil">
              <div class="traingimgname" v-if="item.jzDicName">{{item.jzDicName}}</div>
              <div style="flex:1"></div>
              <div class="traniBox">
                <div class="trainicon" style="margin-right:14px">
                  <img src="@/assets/resource/u231.svg" alt />
                  {{item.visitNum}}
                </div>
                <div class="trainicon" style="margin-right:14px;">
                  <img src="@/assets/videoimg/studycommentPlin.svg" alt />
                  <span>{{item.talkCount}}</span>
                </div>

                <div class="trainicon">
                  <img src="@/assets/videoimg/like.svg" style="width:12px;height:12px" />
                  <span>{{item.assistcount}}</span>
                </div>
              </div>
            </div>
          </div>
          <div style="flex:1"></div>
          <nodata v-if="QuestionList.length==0" style="margin: 0 auto; margin-top: 100px;"></nodata>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as studyClassIndex from '@/api/studyClass/index';
import * as dictionaryst from '@/api/certificate/index';
import treeSelectt from '@/components/treeSelectt'; //文本框选中部门树形结构异步加载
import elSelectc from '@/components/elSelect';
import * as resourceInfo from '@/api/resources/index.js';
import * as pmiDictionary from '@/api/public';
export default {
  components: {
    treeSelectt,
    elSelectc,
  },
  data() {
    return {
      QuestionList: [],
      optionsbx: [],
      levels: 5,
      tabActive: 0,
      listQuery: {
        title: '',
        address: null,
        deptId: 0,
        JzId: null,
        type: '',
        label: '',
      },
      tablist: [
        {
          title: '五星级精品',
          id: 5,
        },
        {
          title: '四星级精品',
          id: 4,
        },
      ],
      options: [
        {
          value: 1,
          label: '专业课',
        },
        {
          value: 3,
          label: '公共课',
        },
      ],
      sid: +new Date(),
      typeOne: 0, //传0过去只显示部门，不穿显示所有部门
      parentIdOne: 2, //只显示该部门以下的
      defaultCheckedKeys: [],
      optionsDicList: [],
    };
  },
  mounted() {
    this.MoocQuestionList();
    this.getListLabel();
    this.getListDic();
  },
  methods: {
    getListDic() {
      let _this = this;
      let data = { NamespaceId: 1 };
      pmiDictionary.getList(data).then((response) => {
        response.result.forEach(function (item, index) {
          let modeInfo = {};
          modeInfo.value = item.id;
          modeInfo.label = item.name;
          modeInfo.code = item.code; //新增的字段
          _this.optionsDicList.push(modeInfo);
        });
      });
    },

    MoocQuestionListssstt() {
      // let title = encodeURIComponent(this.listQuery.title);

      this.$router.push(
        '/mooc/policeAcademyMore?title=' +
          encodeURIComponent(this.listQuery.title)
      );
    },
    // 获取标签字典
    getListLabel() {
      let _this = this;
      let data = { NamespaceId: 65 };
      dictionaryst.getPmiDic(data).then((response) => {
        // console.log(response.data);
        _this.optionsbx = response.result;
      });
    },
    // 类型
    selectChanType(val) {
      // console.log(val);
      this.$router.push('/mooc/policeAcademyMore');
    },
    // 标签
    selectChanged(e) {
      // console.log(e);
      this.listQuery.label = String(e);
      this.$router.push('/mooc/policeAcademyMore?label=' + e);
    },
    // 选择警钟类型返回
    selectDatajzDicId(val) {
      this.listQuery.jzId = val;
      if (val) {
        this.$router.push('/mooc/policeAcademyMore?jzId=' + val);
      }
    },
    //警种部门
    AddDept(checkedIds, checkedData) {
      // console.log(checkedData);
      this.listQuery.deptId = checkedData.id;
      this.$router.push('/mooc/policeAcademyMore?deptId=' + checkedData.id);
    },
    // 更多
    acadMore() {
      this.$router.push('/mooc/policeAcademyMore?levels=' + this.levels);
    },
    MoocQuestionList() {
      let data = { top: 10, Grade: this.levels };
      studyClassIndex.GetWkStartList(data).then((res) => {
        this.QuestionList = res.result;
      });
    },
    //跳转到新页面进入视频的播放
    newsVideo(id) {
      // this.$router.push('/studyclassDetail?id=' + id);
      resourceInfo.DocumentRead(id).then((res) => {});
      this.$router.push('/sourceslist/videoLearn?id=' + id);
    },
    tabHandleChange(index, id) {
      this.tabActive = index;
      this.levels = id;
      this.$emit('tabChange', this.tabActive);
      this.MoocQuestionList();
    },
  },
};
</script>

<style lang="scss" scoped>
.training-school {
  margin-bottom: 14px;
  background: linear-gradient(to bottom, rgb(151, 202, 244) 0px, #fff 304px, #fff 100%);
  border-radius: 4px;
  > .training-school-inner {
    width: 1200px;
    min-height: 550px;
    margin: 0 auto;
    border-radius: 6px;
    .training-school-head {
      width: 100%;
      box-sizing: border-box;
      padding: 0px 19px 6px 21px;
      display: flex;
      align-items: center;
      &>img{
        width: 32px;
        height: auto;
        margin-right: 34px;
      }
      @include themeify {
        border-color: themed('color-border-base');
      }
      .training-schoolul{
        flex: 1;
        display: flex;
        align-items: center;
        .training-school-headtext {
          cursor: pointer;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          margin-right: 11px;
          padding: 3px 6px;
          border-radius: 2px;
          &.active {
            @include themeify {
              color: #fff;
              background-color: rgb(65, 146, 255);
              border-bottom-color: themed('color-background-base');
            }
          }
        }
      }
    }
    .trainingvideo {
      padding: 18px 13px;
      box-sizing: border-box;
      display: flex;
      .trainingvideright {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .trainingimgli{
          width: 222px;
          box-sizing: border-box;
          padding: 6px 6px 8px 6px;
          margin: 0px 16px 20px 0px;
          background-color: #fff;
          box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
          cursor: pointer;
          &:hover {
            box-shadow: 2px 2px 6px rgb(242 242 242 / 99%);
            transform: scale(1.02);
          }
          img {
            width: 100%;
            height: 138px;
            border-radius: 2px;
          }
          .traingimgtext {
            font-size: 16px;
            margin-top: 4px;
            line-height: 24px;
            font-weight: 400;
            color: rgb(39, 38, 54);
            box-sizing: border-box;
            padding: 0px 2px;
          }
          .traingimgnametxtlil {
            color: #999;
            font-size: 14px;
            display: flex;
            margin-top: 6px;
            padding-bottom: 10px;
            .traingimgname {
              padding: 2px 4px;
              color: #fff;
              background-color: #649FED;
              border-radius: 4px;
              font-size: 12px;
              margin-right: 8px;
            }
            .traniBox {
              // flex: 1;
              display: flex;
              padding-right: 5px;
              .trainicon {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 10px;
                line-height: 15px;
                img {
                  width: 16px;
                  height: 16px;
                  margin-right: 2px;
                }
              }
            }
          }
        }
        .trainingimgli:nth-child(5n){
          margin-right: 0px;
        }
      }
    }
  }
}

.gdbox {
  display: flex;
  align-items: center;
  color: rgb(65, 146, 255);
  .gdtext{
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
      color: rgb(65, 146, 255);
    }
  }
}

.play-btn {
  font-size: 50px;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  &:hover {
    cursor: pointer;
  }
}
.gitern {
  height: 2px;
  width: 100%;
  background: linear-gradient(139deg, #1492ff, #d51919);
}
.search-box {
  width: 1200px;
  border-radius: 5px;
  padding: 37px 0px 34px 0px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .select-box {
    display: flex;
    align-items: center;
    .select-title {
      color: #000;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }
  }
}
.onele {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
<style scoped>

/deep/.select-box .el-input__inner{
  border-radius: 4px;
}

/deep/.search-box .input-with-select{
  border-radius: 4px;
  overflow: hidden;
}

/deep/.search-box .searchRightBtnCon{
  background: #545c63;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  height: 40px;
  box-sizing: border-box;
  border: 1px solid #545c63;
  color: white;
  font-size: 16px;
}
</style>
